import React, { useEffect, useState } from "react";
import SupplierPage from "../../../../../entities/DashboardPage/AccountingModule/Supplier/SupplierHome";
import AuthService from "../../../../../api/AuthService";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";

const Supplier = () => {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(1);

  useEffect(() => {
    getSupplierList("", "", page);
  }, [page])

  const getSupplierList = async (text, sort, page) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getSupplier(text, sort, page);
      if (result?.success) {
        setData(result?.data?.suppliers);
        setTotal(result?.data?.total);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleDelete = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.deleteSuppliers(id);
      if (result?.success === true) {
        LoaderHelper.loaderStatus(false);
        getSupplierList();
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  
  const handleFilter = (text, sort) => {
    text ? getSupplierList(text) : sort ? getSupplierList("", sort) : null
  }

  return (
    <SupplierPage page={page} total={total} setPage={setPage} data={data} handleFilter={handleFilter} handleDelete={handleDelete} />
  )

}

export default Supplier;
